function DoctorVO(id, pwz, ewusLogin, ewusNfzOffice, ewusPasswordExpired, doctorPhotoUrl, academicTitle, skipVisitCardValidation,
                  mainSpecialization, specializations, individualPractice, offices, externalSystemSpecializations, assignedPatients,
                  externalSystemIdentifier, firstName, lastName, email, toBeVerified) {
    this.id = id;

    this.pwz = pwz;
    this.ewusLogin = ewusLogin;
    this.ewusNfzOffice = ewusNfzOffice;
    this.ewusPasswordExpired = ewusPasswordExpired;
    this.doctorPhotoUrl = doctorPhotoUrl;
    this.academicTitle = academicTitle;
    this.skipVisitCardValidation = skipVisitCardValidation;
    this.mainSpecialization = mainSpecialization;
    this.specializations = specializations;
    this.individualPractice = individualPractice;
    this.offices = offices;
    this.externalSystemSpecializations = externalSystemSpecializations;
    this.assignedPatients = assignedPatients;
    this.externalSystemIdentifier = externalSystemIdentifier;
    this.toBeVerified = toBeVerified;
    this.firstName = firstName;
    this.lastName = lastName;
    this.email = email;

    var _typeContext = {
        ewusNfzOffice: NfzOfficeVO,
        academicTitle: DictionaryElementVO,
        mainSpecialization: DictionaryElementVO,
        specializations: DictionaryElementVO,
        individualPractice: ClinicVO,
        assignedPatients: PatientVO,
        offices: OfficeVO
    };

    this._getType = function (property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {
    };

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}

DoctorVO.prototype.getFullName = function () {
    return this.firstName + ' ' + this.lastName;
};